var React = require('react');
var cx = require('classnames');
var Button = require('react-bootstrap').Button;
var moment = require('moment');

var CardForm = require('./CardForm');
var Currency = require('../../util/Currency');
var Loading = require('../Loading');
var TokenSelector = require('./TokenSelector');

var GroupedPayment = React.createClass({
    propTypes: {
        amount: React.PropTypes.number.isRequired,
        buttonDisable: React.PropTypes.bool.isRequired,
        buttonIcon: React.PropTypes.node,
        buttonText: React.PropTypes.string.isRequired,
        card: React.PropTypes.object,
        cardErrors: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
        disabled: React.PropTypes.bool.isRequired,
        invoices: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
        invoicesLoading: React.PropTypes.bool,
        onCardUpdate: React.PropTypes.func.isRequired,
        onInvoiceSelection: React.PropTypes.func.isRequired,
        onTokenSelection: React.PropTypes.func.isRequired,
        onPay: React.PropTypes.func.isRequired,
        saveBg: React.PropTypes.bool,
        selectedInvoices: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
        token: React.PropTypes.object,
        tokens: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
        tokensLoading: React.PropTypes.bool,
        working: React.PropTypes.bool
    },
    getDefaultProps: function () {
        return {
            amount: 0,
            buttonDisable: false,
            buttonIcon: <i className="fa fa-credit-card"></i>,
            buttonText: 'Make Payment',
            cardErrors: [],
            disabled: false,
            invoices: [],
            invoicesLoading: false,
            saveBg: false,
            selectedInvoices: [],
            token: null,
            tokenErrors: [],
            tokens: [],
            tokensLoading: false,
            working: false
        }
    },
    getInvoices: function () {
        if (this.props.invoicesLoading) {
            return <p className="form-control-static"><Loading /></p>;
        }

        var invoices = this.props.invoices.map(function (invoice, key) {
            var overdue = moment(invoice.due_date).isBefore();

            var attr = {
                defaultChecked: this.isInvoiceSelected(invoice),
                disabled: this.props.disabled,
                name: "invoices",
                onChange: this.handleInvoiceSelection.bind(null, invoice),
                ref: invoice.id,
                type: "checkbox",
                value: invoice.id
            };

            return <div className={cx('checkbox', { overdue })} key={key}><label>
                <input {...attr} /> {invoice.number} &mdash; {Currency.format(invoice.total - invoice.paid)}
            </label></div>;
        }.bind(this));

        if (!invoices.length) {
            invoices.push(<p key="no-invoices" className="form-control-static">You have no outstanding invoices to pay.</p>);
        }

        return invoices;
    },
    handleInvoiceSelection: function (invoice, e) {
        this.props.onInvoiceSelection(invoice, e.target.checked);
    },
    handleTokenSelection: function (token, e) {
        this.props.onTokenSelection(token);
    },
    isInvoiceSelected: function (searchInvoice) {
        return this.props.selectedInvoices.some(function (invoice) {
            return invoice.id == searchInvoice.id;
        });
    },
    render: function () {
        var errorHelp = [];

        if (this.props.amount <= 0) {
            errorHelp.push(<span key="amount" className="help-block">Select some invoices to pay.</span>); 
        }

        var buttonIcon = this.props.buttonIcon;
        if (this.props.working) {
            buttonIcon = <Loading message="" />;
        }

        return <section className="form-horizontal">
            <form onSubmit={this.props.onPay}>
            <div className="form-group">
                <label className="col-md-3 control-label">Choose Invoices</label>
                <div className="col-md-9">
                    {this.getInvoices()}
                    <span className="help-block">Select the invoices you wish to pay.</span>
                </div>
            </div>
            <div className="form-group" key="downgrade">
                <label className="col-md-3 control-label">Payment Amount</label>
                <div className="col-md-9">
                    <p className="form-control-static">{Currency.format(this.props.amount)}</p>
                    <span className="help-block">
                        This amount will be debited from your selected payment method.
                    </span>
                </div>
            </div>
            {this.renderTokenSelector()}
            {this.renderNewTokenForm()}
            <div className="form-group">
                <div className="col-md-offset-3 col-md-9">
                    <Button bsStyle="success" type="submit" className={cx({ disabled: errorHelp.length || this.props.working || this.props.disabled })}>
                    {buttonIcon} {this.props.buttonText}
                    </Button>
                    {errorHelp}
                </div>
            </div>
            </form>
        </section>;
    },
    renderNewTokenForm: function () {
        return <CardForm
            card={this.props.card}
            cvnOnly={!!this.props.token}
            disabled={this.props.disabled}
            ref="newCard"
            handleUpdate={this.props.onCardUpdate}
            horizontal={[3,4]}
            saveBg={this.props.saveBg}
            showNotice={false}
            violations={this.props.cardErrors}
        />;
    },
    renderTokenSelector: function () {
        var tokenSelector;
        if (this.props.tokensLoading) {
            tokenSelector = <p className="form-control-static"><Loading /></p>;
        } else {
            tokenSelector = <TokenSelector
                disabled={this.props.disabled}
                ref="token"
                selected={this.handleTokenSelection}
                token={this.props.token}
                tokens={this.props.tokens}
            />;
        }

        return <div className="form-group">
            <label className="col-md-3 control-label">Payment Method</label>
            <div className="col-md-9">
                {tokenSelector}
                <span className="help-block">
                    Select which payment method you wish to use to make this payment.
                </span>
            </div>
        </div>;
    }
})
module.exports = GroupedPayment;



// WEBPACK FOOTER //
// ./app/components/Payment/GroupedPayment.js